import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import trackService from "./trackService";

// Fetch visitors
export const fetchOnlineVisitors = createAsyncThunk(
  "track/fetchOnlineVisitors",
  async (_, thunkAPI) => {
    try {
      return await trackService.getOnlineVisitors();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  visitors: [],
  count: 0,
  isLoading: false,
  isError: false,
  message: "",
};

const trackSlice = createSlice({
  name: "track",
  initialState,
  reducers: {
    addVisitor: (state, action) => {
      const payload = action.payload;

      // 1️⃣ INITIAL LOAD FROM SOCKET.IO
      if (payload.type === "initial") {
        state.visitors = payload.data;
        state.count = payload.data.length;
        return;
      }

      // 2️⃣ UPDATE SINGLE VISITOR
      if (payload.type === "update") {
        const updated = payload.data;
        const index = state.visitors.findIndex((v) => v._id === updated._id);

        if (index !== -1) {
          state.visitors[index] = updated; // update
        } else {
          state.visitors.unshift(updated); // add new
        }

        state.count = state.visitors.length;
      }
    },

    clearVisitors: (state) => {
      state.visitors = [];
      state.count = 0;
      state.isError = false;
      state.message = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchOnlineVisitors.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOnlineVisitors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.visitors = action.payload.data || [];
        state.count = action.payload.count || 0;
        state.isError = false;
      })
      .addCase(fetchOnlineVisitors.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch online visitors";
      });
  },
});

export const { addVisitor, clearVisitors } = trackSlice.actions;
export default trackSlice.reducer;
